module.exports = __webpack_public_path__ + "img/Total-Peminjam.a26a84a4.svg";